import React from 'react';
import styled from 'styled-components';
import LoginBox from './LoginBox';
import RecentPostsSection from './RecentPostsSection';
import PointRankingSection from './PointRankingSection';

const LeftSidebar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

interface SidebarProps {
  className?: string;
}

const Sidebar: React.FC<SidebarProps> = ({ className }) => {
  return (
    <LeftSidebar className={className}>
      <LoginBox />
      <RecentPostsSection boardId={1} title="공지사항" noDataText="공지사항이 없습니다." />
      <RecentPostsSection boardId={2} title="자유게시판" noDataText="게시글이 없습니다." />
      <RecentPostsSection title="최신글" noDataText="최신글이 없습니다." />
      <PointRankingSection />
    </LeftSidebar>
  );
};

export default Sidebar; 